import React from 'react'
import { styles } from './index.sass'
import { ContentGenerator } from '../../components/contentGenerator/ContentGenerator'
import { sendEmail, sendTestEmail } from '../../api/mailchimp'
import { refineRundown } from '../../api/contentGeneration'
import { loadUser } from '../../utils/storage'

export const Rundown = () => {
  const isValidUrl = (string) => {
    try {
      new URL(string)
      return true
    } catch (_) {
      return false
    }
  }

  const handleLoadTestData = (setContentHtml) => {
    const testContent = `
      <h1>Rundown: The Benefits of Yoga</h1>
      <p>Here's a comprehensive rundown of how yoga can improve your health and wellness:</p>
      
      <h2>Physical Benefits</h2>
      <ul>
        <li>Improves flexibility and range of motion</li>
        <li>Strengthens muscles and improves posture</li>
        <li>Reduces inflammation and chronic pain</li>
      </ul>
      
      <h2>Mental Benefits</h2>
      <ul>
        <li>Reduces stress and anxiety</li>
        <li>Improves focus and concentration</li>
        <li>Enhances mood and emotional well-being</li>
      </ul>
      
      <h2>Overall Wellness</h2>
      <ul>
        <li>Boosts immune system function</li>
        <li>Improves sleep quality</li>
        <li>Promotes healthy aging</li>
      </ul>
      
      <p>Incorporating yoga into your daily routine can lead to significant improvements in both physical and mental health. Start with just 10-15 minutes a day!</p>
    `
    setContentHtml(testContent)
  }

  const handleGenerate = async (topic, regenerate, onStepUpdate) => {
    if (!topic.trim()) {
      throw new Error('Please enter an Apeiron Blog URL')
    }

    if (!isValidUrl(topic.trim())) {
      throw new Error('Please enter a valid URL (e.g., https://www.blog.apeiron.life/post/the-link-between-parkinson-s-disease-and-golf)')
    }

    return new Promise((resolve, reject) => {
      const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-rundown-stream`
      const user = loadUser()
      const eventSource = new EventSource(`${url}?url=${encodeURIComponent(topic)}&regenerate=${true}&expert_name=${user && user.full_name ? user.full_name : ''}`)

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data)
        
        if (data.step !== undefined && onStepUpdate) {
          onStepUpdate(data)
        } else if (data.status === 'success') {
          eventSource.close()
          resolve({
            success: true,
            content_html: data.content_html,
            message: 'Rundown email generated successfully!'
          })
        } else if (data.status === 'error') {
          eventSource.close()
          reject(new Error(data.message || 'Failed to generate rundown email'))
        }
      }

      eventSource.onerror = () => {
        eventSource.close()
        reject(new Error('Stream connection error'))
      }
    })
  }

  return (
    <div className={styles}>
      <ContentGenerator
        title="Rundown Email Generator"
        inputPlaceholder="Enter Apeiron Blog URL (e.g., https://www.blog.apeiron.life/post/the-link-between-parkinson-s-disease-and-golf)"
        generateButtonText="Generate Rundown"
        regenerateButtonText="Regenerate"
        editButtonText="Refine with AI"
        sendEmailButtonText="Send Email"
        sendTestEmailButtonText="Send Test Email"
        loadTestDataButtonText="Load Test Data"
        onGenerate={handleGenerate}
        onRefine={refineRundown}
        onSendEmail={sendEmail}
        onSendTestEmail={sendTestEmail}
        onLoadTestData={handleLoadTestData}
      />
    </div>
  )
}
